import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addAlert } from "src/modules/notification/redux";
import updateCompanySalesEmail from "src/configs/apis/companies/updateComapnySalesEmail.api";
import CompanySalesEmailDialogComponent from "./company-sales-email-dialog.component";

export default function CompanySalesEmailDialogContainer({
  selectedCompany,
  onCompanySalesEmailDialogCloseClick,
  onSuccess, // optional callback to refresh data
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isMountedRef = useRef(true);
  const dispatch = useDispatch();

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleSubmit = async (values, formikHelpers) => {
    setIsSubmitting(true);
    try {
      const id = selectedCompany.company?.id || selectedCompany.id;
      await updateCompanySalesEmail(id, values.salesEmail);
      dispatch(
        addAlert({
          severity: "success",
          message: "Sales email updated successfully",
        })
      );
      if (onSuccess) {
        onSuccess();
      }
      if (onCompanySalesEmailDialogCloseClick) {
        onCompanySalesEmailDialogCloseClick();
      }
    } catch (error) {
      dispatch(
        addAlert({
          severity: "error",
          message: "Failed to update sales email",
        })
      );
      formikHelpers.setSubmitting(false);
      formikHelpers.setStatus({ error: "Failed to update sales email." });
    } finally {
      if (isMountedRef.current) {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <CompanySalesEmailDialogComponent
      selectedCompany={selectedCompany}
      onCompanySalesEmailDialogSubmitClick={handleSubmit}
      onCompanySalesEmailDialogCloseClick={onCompanySalesEmailDialogCloseClick}
      isSubmitting={isSubmitting}
    />
  );
}
